import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function HomeArticles() {
  const featured = articles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
              最新攻略资讯
            </h2>
            <p className="text-sm text-foreground-500">掌握PG国际008最新动态与游戏攻略</p>
          </div>
          <Link
            to="/articles"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                  {article.category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-4">{article.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-6 sm:hidden">
          <Link
            to="/articles"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看全部攻略资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}